import { reactive } from "vue";
import { lock, unlock } from '@js/body-scroll-lock.js';

export const store = reactive({
	navDrawerOpen: false,
	openModal: null,
	modalConfig: {},
	search: {
		beds: '2+ Beds',
		baths: '1+ Baths',
		sqft: 'Any Sq Ft',
		acres: 'Any Acres',
		price: 'Any Price',
		location: 'Any Location',
	},
});

export const mutations = {
	toggleNavDrawer() {
		store.navDrawerOpen = !store.navDrawerOpen;
	},
	closeNavDrawer() {
		store.navDrawerOpen = false;
	},
	openNavDrawer() {
		store.navDrawerOpen = true;
	},
	openModal(id, config = {}) {
		if (store.openModal === null) {
			lock();
		}
		console.log('Opening modal', id, config);
		store.modalConfig = config;
		store.openModal = id;
	},
	closeModal(id) {
		if (id && id !== store.openModal) {
			return;
		}
		if (store.openModal !== null) {
			unlock();
		}
		store.openModal = null;
		store.modalConfig = {};
	},
};
